module.exports = {
  build: {
    VUE_APP_APIURL_BKBCUP: 'https://hyper-sports.mixtmt.com', // 篮球杯赛【女子亚洲杯】
    VUE_APP_APIURL_FTLEAGUE: 'https://hyper-sports.mixtmt.com', //足球联赛【中超】
    VUE_APP_APIURL_TENNIS: 'https://hyper-sports.mixtmt.com', //网球
    VUE_APP_APIURL_DATAPOSTER: 'https://hyper-sports.mixtmt.com', //数据海报
    VUE_APP_APIURL_PROG: 'https://hyper-sports.mixtmt.com', // 节目单
    VUE_APP_APIURL_BADMINTON: 'https://hyper-sports.mixtmt.com', //羽毛球
    VUE_APP_APIURL_BASKETBALL: 'https://hyper-sports.mixtmt.com', //篮球
    VUE_APP_APIURL_WORLDCUP: 'https://hyper-sports.mixtmt.com', //世界杯
    VUE_APP_APIURL_CSMEET: 'https://hyper-sports.mixtmt.com', //综合性运动会
    VUE_APP_APIURL_MARATHON: 'https://hyper-sports.mixtmt.com', //marathon
    VUE_APP_APIURL_API: 'https://hyper-sports-mr.mixtmt.com', //api
    VUE_APP_ISCACHEAPIURL: 'https://hyper-sports.mixtmt.com', //后端静态化地址
    VUE_APP_H5URL: 'https://eventdata-web.5club.cctv.cn', //前端域名
  },
  buildDev: {
    VUE_APP_APIURL_BKBCUP: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_FTLEAGUE: 'https://stag-hyper-sports.mixtmt.com', //足球联赛【中超】
    VUE_APP_APIURL_TENNIS: 'https://stag-hyper-sports.mixtmt.com', //网球
    VUE_APP_APIURL_DATAPOSTER: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_PROG: 'https://stag-hyper-sports.mixtmt.com', // 节目单
    VUE_APP_APIURL_BADMINTON: 'https://stag-hyper-sports.mixtmt.com', //羽毛球
    VUE_APP_APIURL_BASKETBALL: 'https://stag-hyper-sports.mixtmt.com', //篮球
    VUE_APP_APIURL_WORLDCUP: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_CSMEET: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_MARATHON: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_API: 'https://stag-hyper-sports-mr.mixtmt.com',
    VUE_APP_ISCACHEAPIURL: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_H5URL: 'https://hyper-sports.mixtmt.com',
  },
  dev: {
    VUE_APP_APIURL_BKBCUP: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_FTLEAGUE: 'https://stag-hyper-sports.mixtmt.com', //足球联赛【中超】
    VUE_APP_APIURL_TENNIS: 'https://stag-hyper-sports.mixtmt.com', //网球
    VUE_APP_APIURL_DATAPOSTER: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_PROG: 'https://stag-hyper-sports.mixtmt.com', // 节目单
    VUE_APP_APIURL_BADMINTON: 'https://stag-hyper-sports.mixtmt.com', //羽毛球
    VUE_APP_APIURL_BASKETBALL: 'https://stag-hyper-sports.mixtmt.com', //篮球
    VUE_APP_APIURL_WORLDCUP: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_CSMEET: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_MARATHON: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_APIURL_API: 'https://stag-hyper-sports-mr.mixtmt.com',
    VUE_APP_ISCACHEAPIURL: 'https://stag-hyper-sports.mixtmt.com',
    VUE_APP_H5URL: 'https://hyper-sports.mixtmt.com',
  },
}
